module.exports = __webpack_public_path__ + "img/link-external-01.c0bfb936.svg";